import { Inject, Injectable, Injector, LOCALE_ID } from '@angular/core';
import { BaseApiService } from '@carm/_core/baseapi.service';
import { Observable } from 'rxjs';
import { IMassAdjustmentFormModel } from '../models/form/mass-adjustment-form.model';
import { mapSubmitMassAdjustmentFormModelToRequest } from '../models/common/mass-adjustment-mappers';
import { mergeMap, map } from 'rxjs/operators';
import { MetaDropdowns } from '../models/common/meta-dropdowns.model';
import { countryCodeUS } from '../models/declaration-consts';
import { IMassAdjustmentCaseResponse, IMassAdjMetadataResponse } from '../models/mass-adjustment-api.model';

@Injectable()
export class MassAdjustmentService extends BaseApiService {

  constructor(protected injector: Injector, @Inject(LOCALE_ID) private localeId: string) {
    super(injector);
  }

  get cadMassAdjustmentUrl(): string {
    return `${this.endPointBP}/cad/massadjustment`;
  }

  createMassAdjustmentCase(formData: IMassAdjustmentFormModel): Observable<IMassAdjustmentCaseResponse> {
    const endPoint = `${this.cadMassAdjustmentUrl}/create-case`;
    return this.httpAuthPost<IMassAdjustmentCaseResponse>(endPoint, {complianceCaseNo: formData.complianceCaseNo});
  }

  createCase(): Observable<IMassAdjustmentCaseResponse> {
    const endPoint = `${this.cadMassAdjustmentUrl}/create-case-draft`;
    return this.httpAuthPost<IMassAdjustmentCaseResponse>(endPoint, {});
  }

  submitCase(caseId: string): Observable<IMassAdjustmentCaseResponse> {
    const endPoint = `${this.cadMassAdjustmentUrl}/submit-case/${caseId}`;
    return this.httpAuthPatch<IMassAdjustmentCaseResponse>(endPoint, {});
  }

  getEditFields(level: string): Observable<IMassAdjMetadataResponse> {
    const endPoint = `${this.cadMassAdjustmentUrl}/declaration-fields/${level}`;
    return this.httpAuthGet<IMassAdjMetadataResponse>(endPoint);
  }

  submitMassAdjustment(
    formData: IMassAdjustmentFormModel , thirdPartyBN15?: string
  ): Observable<IMassAdjustmentCaseResponse> {

    if(formData.adjustFields.find(field => (field.fieldName === MetaDropdowns.CountryOfOrigin) && (field.newValue !== countryCodeUS))) { // if anything but USA is selected, set state to null
      formData.adjustFields.push({fieldName: MetaDropdowns.USState, fieldText: null, newValue: null, newValueText: null });
    }

    if(formData.adjustFields.find(field => (field.fieldName === MetaDropdowns.PlaceOfExport) && (field.newValue !== countryCodeUS))) { // if anything but USA is selected, set state to null
      formData.adjustFields.push({fieldName: MetaDropdowns.PlaceOfExportState, fieldText: null, newValue: null, newValueText: null });
    }

    const surtaxSubjectfield = formData.adjustFields.find(item => item.fieldName ===  MetaDropdowns.SurtaxSubject);

    if (surtaxSubjectfield && surtaxSubjectfield.newValue == null){
        surtaxSubjectfield.newValue = '';
    }

    return this.createMassAdjustmentCase(formData).pipe(
      mergeMap(response => {
        const biz = this.cadMassAdjustmentUrl.indexOf('business/') + 9;
        const importerBN = this.cadMassAdjustmentUrl.substring(biz, biz + 9);
        const payload = mapSubmitMassAdjustmentFormModelToRequest(
          formData,
          response.caseNumber,
          this.localeId,
          importerBN, 
          thirdPartyBN15
        );
        const endPoint = `${this.cadMassAdjustmentUrl}/create-details`;
        const iMassAdjustmentCaseResponse = response;
        return this.httpAuthPost<IMassAdjustmentCaseResponse>(
          endPoint,
          payload
        ).pipe(
          map(data => {
            return iMassAdjustmentCaseResponse;
          })
        );
      })
    );
  }
}
